/* eslint-disable key-spacing,no-multi-spaces */

export default {
  Cash:                 { OnSite: true,   Online: false,  NotApplicable: false },
  Check:                { OnSite: true,   Online: false,  NotApplicable: false },
  CreditCard:           { OnSite: true,   Online: true,   NotApplicable: false },
  DebitCard:            { OnSite: true,   Online: true,   NotApplicable: false },
  DirectDebit:          { OnSite: false,  Online: false,  NotApplicable: true },
  MobilePayment:        { OnSite: true,   Online: true,   NotApplicable: false },
  BankTransfer:         { OnSite: false,  Online: false,  NotApplicable: true },
  Voucher:              { OnSite: true,   Online: true,   NotApplicable: false },
  AccountTransfer:      { OnSite: false,  Online: false,  NotApplicable: true },
  HouseAccount:         { OnSite: false,  Online: false,  NotApplicable: true },
  CustomerCard:         { OnSite: true,   Online: true,   NotApplicable: false },
  InternalConsumption:  { OnSite: false,  Online: false,  NotApplicable: true },
  Other:                { OnSite: false,  Online: true,   NotApplicable: true },
};



// WEBPACK FOOTER //
// ./src/lib/paymentMethodUtils.js